import type { ReportHeatmapColorStop } from './types'

export const DEFAULT_COLOR_STOPS: ReadonlyArray<ReportHeatmapColorStop> = [
  { at: 0, color: '#183a8a' },
  { at: 0.5, color: '#f2e7ab' },
  { at: 1, color: '#b42318' },
]

export const DEFAULT_BACKGROUND_COLOR = '#ffffff'
export const DEFAULT_TEXT_COLOR = '#172033'
export const DEFAULT_AXIS_COLOR = '#172033'
export const DEFAULT_GRID_COLOR = 'rgba(23, 32, 51, 0.12)'
export const DEFAULT_MISSING_COLOR = '#d1d5db'
export const DEFAULT_CELL_SIZE = 16
export const DEFAULT_LEGEND_WIDTH = 160
export const DEFAULT_LEGEND_HEIGHT = 240
export const DEFAULT_FONT_FAMILY = 'Arial, sans-serif'

export const FNV64_OFFSET = 0xcbf29ce484222325n
export const FNV64_PRIME = 0x100000001b3n
export const FNV64_MASK = 0xffffffffffffffffn
